import React, { CSSProperties } from 'react';
import { computed, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

import { InjectedStyledComponent } from '../../../../../shared/index.js';
import { ITableEvents } from '../../models/index.js';
import { ITableGroup } from '../../models/ITableGroup.js';
import Row from '../Row/Row.js';
import { TableComponentBase } from '../TableComponentBase.js';

import { IBodyConfiguration, IBodyProps, IBodyState } from './models/index.js';
import { BODY_CATEGORY_KEY, BODY_COMPONENT_KEY, BODY_PARENT_COMPONENT_KEY } from './Body.meta.js';

export class Body extends TableComponentBase<
	IBodyProps & React.TableHTMLAttributes<HTMLTableSectionElement>,
	IBodyState,
	IBodyConfiguration
> {
	categoryKey = BODY_CATEGORY_KEY;
	componentKey = BODY_COMPONENT_KEY;
	get parentComponentKey(): string | undefined {
		return BODY_PARENT_COMPONENT_KEY;
	}
	get tableEventsKey(): keyof ITableEvents {
		return 'body';
	}
	constructor(props: IBodyProps) {
		super(props);

		makeObservable(this, {
			grouping: computed,
		});
	}

	get grouping(): ITableGroup | null {
		return this.table && this.table.grouping;
	}
	render() {
		const {
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			children,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			configuration,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyle,
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			componentStyleProps,

			table,
			rows = [],
			suppressAnalytics,
			analyticsContext,
			stickyProps,
			...otherProps
		} = this.props;
		const events = this.getEvents(this.eventsForElement);
		const groupStickyStyles: CSSProperties =
			(stickyProps &&
				stickyProps.groupTop && {
					position: 'sticky',
					top: stickyProps.groupTop,
					zIndex: stickyProps.groupZIndex,
				}) ||
			{};
		return (
			<tbody {...events} {...otherProps}>
				{rows.map((row, rowIndex) => {
					const key = this.getRowKey(row, rowIndex);
					const rowStyleProps = this.getRowStyleProps(row, rowIndex, this.grouping);
					return (
						<Row
							style={groupStickyStyles}
							{...rowStyleProps}
							key={key}
							table={table}
							row={row}
							rowIndex={rowIndex}
							grouping={this.grouping}
							suppressAnalytics={suppressAnalytics}
							analyticsContext={analyticsContext}
						/>
					);
				})}
			</tbody>
		);
	}
}

export default InjectedStyledComponent(observer(Body), BODY_CATEGORY_KEY, BODY_PARENT_COMPONENT_KEY, [
	BODY_COMPONENT_KEY,
]);
